<template>
  <div class="activity-page">
    <headers />
    <div class="invite-content">
      <div class="invite-box">
        <div class="activity-content">
          <div class="invite-title">活动内容</div>
          <div class="invite-rules">
            1、活动期间，每成功邀请一位亚马逊卖家注册并使用快现形，将可获得20次免费查询奖励，单账号最高可获得500次免费查询奖励。
          </div>
          <div class="invite-rules">
            2、活动有效期：2023年7月1日—2023年12月31日
          </div>
          <!-- <div class="invite-rules">
            2、邀请获取的免费查询奖励，统一在2022年5月30日失效。
          </div>-->
        </div>
        <div class="invite-method">
          <div class="invite-title">邀请方法</div>
          <div class="invite-rules">
            1. 使用二维码邀请：<span>右键复制（鼠标右键 -> 复制图片）</span>下方专属邀请二维码，使用微信转发给您的同事或朋友。
          </div>
          <div class="invite-rules">
            二维码有效期至&nbsp;{{ ticket.expirationDate }}
          </div>
          <div class="qrcode-box">
            <div class="qrcode" ref="qrCodeUrl" v-if="qrCodeUrl"></div>
          </div>
          <div class="invite-rules">
            2. 使用链接邀请：
            <span class="link-url" ref="link">{{ copyVal }}</span>
            <span class="tap-clone" @click="tapCopyLink">复制链接</span>
          </div>
        </div>
      </div>
      <div class="right-copy">本活动最终解释权归快现形所有</div>
    </div>
    <right-icon />
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { getCustomerTicket } from '@/api/activity.js'
import Headers from '@/components/Header/index.vue'
import RightIcon from '@/components/right-icon/index.vue'
export default {
  name: 'inviteActivity',
  components: {
    Headers,
    RightIcon
  },
  props: {},
  data() {
    return {
      ticket: {},
      qrCodeUrl: '',
      tableData: [],
      copyVal: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getCustomerTicket()
  },
  methods: {
    creatQrCode() {
      this.$nextTick(() => {
        this.$refs.qrCodeUrl.innerHTML = ''
        new QRCode(this.$refs.qrCodeUrl, {
          text: this.qrCodeUrl, // 需要转换为二维码的内容
          width: 180,
          height: 180,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },
    tapCopyLink() {
      window.getSelection().selectAllChildren(this.$refs.link);
      document.execCommand("copy")
      this.$message.success('复制成功')
    },
    getCustomerTicket() {
      getCustomerTicket().then(res => {
        if (res.success) {
          this.ticket = res.data
          this.copyVal = process.env.NODE_ENV === 'production' ? `https://${location.host}/home?zbuc=${res.data.customerCode}` : `http://${location.host}/home?zbuc=${res.data.customerCode}`
          this.qrCodeUrl = res.data.url
          this.creatQrCode()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.activity-page {
  padding-top: 20px;
}

.invite-content {
  display: flex;
  justify-content: center;
  position: relative;

  .invite-box {
    position: relative;
    width: 1200px;
    height: 1038px;
    background: url('../../assets/activity/invite-activity-bg.png') no-repeat;
    background-size: 100% 100%;
    color: #373e4f;

    .invite-title {
      width: 988px;
      font-size: 30px;
      text-align: center;
      margin-bottom: 28px;
    }

    .invite-rules {
      font-size: 16px;
      line-height: 32px;

      .look-img {
        cursor: pointer;
        font-weight: 400;
        color: #3c7cff;
      }

      span {
        color: #ffa200;
      }

      .link-url {
        color: #373e4f;
      }
    }

    .activity-content {
      position: absolute;
      top: 325px;
      left: 50%;
      transform: translate(-50%, 0);
    }

    .invite-method {
      position: absolute;
      top: 600px;
      left: 50%;
      transform: translate(-50%, 0);

      .qrcode-box {
        display: flex;
        justify-content: center;
        width: 988px;

        .qrcode {
          border: 1px solid #FC634E;
          padding: 8px;
          margin: 10px auto;
          margin-top: 0;
        }
      }

      .tap-clone {
        margin-left: 8px;
        cursor: pointer;
        color: #3c7cff;
      }
    }
  }

  .right-copy {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: 12px;
    text-align: center;
    font-size: 16px;
    color: #fff;
  }
}
</style>
